import React, { useState, useEffect, useRef } from "react";
import * as Utils from "../utils/Utils.js";

const DescriptionText = ({ content, widthProp, isEventPage }) => {
  const [expanded, setExpanded] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const textRef = useRef(null);

  const toggleViewMore = (e) => {
    e.preventDefault();
    setExpanded((prevState) => !prevState);
    if (expanded) {
      Utils.smoothScroll(document.querySelector(".r_descriptionText"));
    }
  };

  const checkOverflow = () => {
    const contentDiv = textRef.current;
    if (contentDiv) {
      const contentHeight = contentDiv.scrollHeight;
      const divHeight = 528;
      const showButtonsVal = contentHeight > divHeight;
      setShowButtons(showButtonsVal);
    }
  };

  useEffect(() => {
    checkOverflow();
  }, []);

  const contentStyle = {
    maxHeight: "none",
    maxWidth: widthProp,
  };

  const withGradientStyle = {
    maxHeight: isEventPage ? "569px" : "434px",
    overflow: "hidden",
    maxWidth: widthProp,
    position: "relative",
  };

  return (
    <>
      {showButtons ? (
        <div className="r_descriptionText">
          {expanded ? (
            <>
              <div
                style={contentStyle}
                className="r_descriptionExpanded"
                ref={textRef}
                dangerouslySetInnerHTML={{ __html: content }}
              />
              <div onClick={toggleViewMore} className="r_viewMoreButton">
                <div className="r_viewless">
                  {playdetailsv2_resources.ViewLess}
                </div>
              </div>
            </>
          ) : (
            <>
              <div
                style={withGradientStyle}
                className="r_descriptionWithGradient"
                ref={textRef}
                dangerouslySetInnerHTML={{ __html: content }}
              />
              <div onClick={toggleViewMore} className="r_viewMoreButton">
                <span>{playdetailsv2_resources.ViewMore}</span>
              </div>
            </>
          )}
        </div>
      ) : (
        <div
          className="r_descriptionText"
          style={{ maxWidth: widthProp }}
          ref={textRef}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </>
  );
};

export default DescriptionText;
